module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-page"
  }, [(_vm.info) ? _c('article', [_c('section', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.info.data.text))
    }
  }), _c('section', {
    staticClass: "clients"
  }, [_c('h1', {
    staticClass: "heading"
  }, [_vm._v("Select Clients")]), _vm._l((_vm.info.data.clients), function(list) {
    return _c('div', [_c('h2', {
      staticClass: "heading",
      domProps: {
        "innerHTML": _vm._s(list.header[0].text)
      }
    }), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.html(list.list))
      }
    })])
  })], 2), _c('footer', [_c('copyright', {
    attrs: {
      "credits": "credits"
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0de329ed","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Info.vue
// module id = 147
// module chunks = 1